import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import Counter from "../../Tool/Counter/Counter";
import {
  Alert,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Col,
} from "reactstrap";

import * as UTILS from "../../../utils/Utils";
import classnames from "classnames";
import LinkOption from "../../Tool/LinkOption/LinkOption";
import "./Image.scss";
import cloneDeep from "lodash.clonedeep";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";
import noImage from '../../../assets/images/noimage.png'
import RangeInputSlider from "../../Tool/RangeSlider";

class ImageSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickedImageID: null,
      imageLibrary: false,
      opacity: 1,
      id: null,
      activeTabModal: "1",
      email: "",
      emailError: true,
    };
  }
  componentDidMount = () => {
    this.setState({
      opacity: this.props.opacity,
      email: this.props.LinkType == "email" ? this.props.Link : "",
    });
  };
  toggleModalTabl(tab) {
    if (this.state.activeTabModal !== tab) {
      this.setState({
        activeTabModal: tab,
      });
    }
  }
  setIdForEditHandler = (editID) => {
    this.setState({
      id: editID,
    });
  };

  removeImage = () => {
    const layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.src = null;
        item.srcID = null;
      },
      (colItem) => {
        colItem.src = null;
        colItem.srcID = null;
      },
      (colItemNested) => {
        colItemNested.src = null;
        colItemNested.srcID = null;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  widthToggle = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.checked == true ? "" : "400";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value > 1 ? value : "1";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  unitValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  mobileAlign = (e) => {
    const layout = cloneDeep(this.props.layout);
    // const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.mobileAlign = e.target.value;
      },
      (colItem) => {
        colItem.mobileAlign = e.target.value;
      },
      (colItemNested) => {
        colItemNested.mobileAlign = e.target.value;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  // Border radius ENDS

  // Height CONTROLS

  opacityChangeHandler = (value) => {
    this.setState(
      {
        opacity: value,
      },
      () => {
        let layout = cloneDeep(this.props.layout);
        const selectedValue = this.state.opacity;
        const newLayout = UTILS.UpdateLayout(
          layout,
          this.props.ID,
          (item) => {
            item.style.opacity = selectedValue;
          },
          (colItem) => {
            colItem.style.opacity = selectedValue;
          },
          (colItemNested) => {
            colItemNested.style.opacity = selectedValue;
          }
        );
        this.props.layoutArray(this.props.layoutTitle, newLayout);
      }
    );
  };
  onChangeAlign = (e) => {
    let layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style.float = selectedValue;
      },
      (colItem) => {
        colItem.style.float = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style.float = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  addImageLabel = (event) => {
    /* signal to React not to nullify the event object */
    event.persist();

    const layout = cloneDeep(this.props.layout);
    const selectedValue = event.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.label = selectedValue;
      },
      (colItem) => {
        colItem.label = selectedValue;
      },
      (colItemNested) => {
        colItemNested.label = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  render() {
    return (
      <>
        {" "}
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTabModal === "1",
              })}
              onClick={() => {
                this.toggleModalTabl("1");
              }}
            >
              General
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: this.state.activeTabModal === "2",
              })}
              onClick={() => {
                this.toggleModalTabl("2");
              }}
            >
              Link
            </NavLink>
          </NavItem>
        </Nav>
        <div className="modalScrollContainer">
          <TabContent
            className="buttonSettingWrapper"
            activeTab={this.state.activeTabModal}
          >
            <TabPane tabId="1" className="general-tab">
              <div className="modalContentWrapper">
                <div className="imageOptions">
                  <label>
                    Image Label <small> (For Meta Data and Aria Labels)</small>
                  </label>
                  <input
                    onChange={this.addImageLabel}
                    defaultValue={this.props.label}
                    placeholder="Add Image Label"
                    className="imageLabelInput"
                    type="text"
                  />
                  {this.props.src && (
                    <div
                      style={{ marginBottom: "20px" }}
                      className="selectedImageThumb"
                    >
                      <img
                        onError={(e) => {
                          e.target.src = noImage;
                        
                        }}
                        style={{
                          marginTop: "20px",
                          marginBottom: "20px",
                          maxWidth: "300px",
                          maxHeight: "auto",
                          boxShadow: "0 0 10px 0px #0078ff",
                          border: "solid 1px #0078ff",
                        }}
                        src={this.props.src}
                      />
                    </div>
                  )}
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    {this.props.src ? (
                      <button
                        className="select-various-content-button"
                        onClick={this.props.changeImage}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17.8"
                          height="17.8"
                          viewBox="0 0 17.8 17.8"
                        >
                          <g id="image" transform="translate(-0.6 -2.1)">
                            <rect
                              id="Rectangle_733"
                              data-name="Rectangle 733"
                              width="16"
                              height="16"
                              rx="2"
                              transform="translate(1.5 3)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.8"
                            />
                            <circle
                              id="Ellipse_10"
                              data-name="Ellipse 10"
                              cx="1.5"
                              cy="1.5"
                              r="1.5"
                              transform="translate(4.467 6.467)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.8"
                            />
                            <path
                              id="Path_348"
                              data-name="Path 348"
                              d="M18.4,14.5,14.537,10,4,20"
                              transform="translate(-2 -2)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.8"
                            />
                          </g>
                        </svg>
                        Change Image
                      </button>
                    ) : (
                      <button
                        className="select-various-content-button"
                        onClick={this.props.changeImage}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17.8"
                          height="17.8"
                          viewBox="0 0 17.8 17.8"
                        >
                          <g id="image" transform="translate(-0.6 -2.1)">
                            <rect
                              id="Rectangle_733"
                              data-name="Rectangle 733"
                              width="16"
                              height="16"
                              rx="2"
                              transform="translate(1.5 3)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.8"
                            />
                            <circle
                              id="Ellipse_10"
                              data-name="Ellipse 10"
                              cx="1.5"
                              cy="1.5"
                              r="1.5"
                              transform="translate(4.467 6.467)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.8"
                            />
                            <path
                              id="Path_348"
                              data-name="Path 348"
                              d="M18.4,14.5,14.537,10,4,20"
                              transform="translate(-2 -2)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.8"
                            />
                          </g>
                        </svg>
                        Add Image
                      </button>
                    )}
                    {this.props.src ? (
                      <button
                        className="select-various-content-button"
                        style={{ marginLeft: "10px" }}
                        onClick={this.removeImage}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <g id="delete" transform="translate(34.5 5.5)">
                            <g id="trash" transform="translate(-32.5 -3.5)">
                              <path
                                id="Path_363"
                                data-name="Path 363"
                                d="M3,6H16.539"
                                transform="translate(0 -0.991)"
                                fill="none"
                                stroke="#0c3254"
                                strokeLinecap="square"
                                strokeWidth="1.3"
                              />
                              <path
                                id="Path_364"
                                data-name="Path 364"
                                d="M15.53,5.009v10.53a1.5,1.5,0,0,1-1.5,1.5H6.5a1.5,1.5,0,0,1-1.5-1.5V5.009m2.257,0V3.5A1.5,1.5,0,0,1,8.761,2H11.77a1.5,1.5,0,0,1,1.5,1.5v1.5"
                                transform="translate(-0.496)"
                                fill="none"
                                stroke="#0c3254"
                                strokeLinecap="square"
                                strokeWidth="1.3"
                              />
                              <line
                                id="Line_64"
                                data-name="Line 64"
                                y2="4.513"
                                transform="translate(8.265 8.77)"
                                fill="none"
                                stroke="#0c3254"
                                strokeLinecap="square"
                                strokeWidth="1.3"
                              />
                              <line
                                id="Line_65"
                                data-name="Line 65"
                                y2="4.513"
                                transform="translate(11.274 8.77)"
                                fill="none"
                                stroke="#0c3254"
                                strokeLinecap="square"
                                strokeWidth="1.3"
                              />
                            </g>
                          </g>
                        </svg>
                        Remove Image
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>

              <div
                style={{ marginTop: "30px", marginBottom: "20px" }}
                className="padding-section"
              >
                <div className="heading">Size and Opacity</div>
              </div>
              <div className="modalContentWrapper">
                {" "}
                <div style={{display: 'flex', flexDirection: 'column', }}>
                  <label>
                    Opacity <small>(Set range for image opacity)</small>
                  </label>
                  <RangeInputSlider
                    widthValue={this.state.opacity}
                    
                    onChangeHandler={(widthVal) => {
                      this.opacityChangeHandler(widthVal);
                    }}
                    maxWidthRange={1}
                    step={0.001}
                  />
                </div>
                {this.props.children}
              </div>

              <div style={{ marginBottom: "20px" }} className="padding-section">
                <div className="heading">Alignment</div>
              </div>
              <div className="modalContentWrapper">
                <div className="row imageSettingCounter">
                  <div className="col-sm-6 bottomSpace imageAlign">
                    <label>Image Align in Desktop</label>
                    <div className="modalSetting">
                      <select
                        value={this.props.float}
                        onChange={this.onChangeAlign}
                      >
                        <option value="left">Left</option>
                        <option value="none">Center</option>
                        <option value="right">Right</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6 bottomSpace imageAlign">
                    <label>Image Align in Mobile</label>
                    <div className="modalSetting">
                      <select
                        value={this.props.mobileAlign}
                        onChange={this.mobileAlign}
                      >
                        <option>Select</option>
                        <option value="left">Left</option>
                        <option value="none">Center</option>
                        <option value="right">Right</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Margin</div>
              </div>
              <div className="modalContentWrapper">
                <div className="col-sm-12">
                  <div className="heading-row">
                    <div
                      className="heading-row"
                      style={{ justifyContent: "flex-end" }}
                    >
                      <UnitSelector
                        value={
                          this.props.imageMarginUnit
                            ? this.props.imageMarginUnit
                            : "px"
                        }
                        onChange={(e) => {
                          this.unitValueChange(e, "imageMarginUnit");
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row bottom-margin options">
                  <div className="col-sm-3">
                    <Counter
                      label="Top"
                      small={
                        this.props.imageMarginUnit === "%" ? "percent" : "pixel"
                      }
                      minusClick={() =>
                        this.counterMinus(this.props.marginTop, "marginTop")
                      }
                      plusClick={() =>
                        this.counterPlus(this.props.marginTop, "marginTop")
                      }
                      valueContent={this.props.marginTop}
                      disabled={false}
                      onChange={(e) => {
                        this.counterChange(e, "marginTop");
                      }}
                    />
                  </div>

                  <div className="col-sm-3">
                    <Counter
                      label="Bottom"
                      small={
                        this.props.imageMarginUnit === "%" ? "percent" : "pixel"
                      }
                      minusClick={() =>
                        this.counterMinus(
                          this.props.marginBottom,
                          "marginBottom"
                        )
                      }
                      plusClick={() =>
                        this.counterPlus(
                          this.props.marginBottom,
                          "marginBottom"
                        )
                      }
                      valueContent={this.props.marginBottom}
                      disabled={false}
                      onChange={(e) => {
                        this.counterChange(e, "marginBottom");
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Border</div>
              </div>
              <div className="modalContentWrapper">
                <Counter
                  label="Border Radius"
                  minusClick={() =>
                    this.counterMinus(this.props.radius, "borderRadius")
                  }
                  plusClick={() =>
                    this.counterPlus(this.props.radius, "borderRadius")
                  }
                  valueContent={this.props.radius}
                  disabled={false}
                  onChange={(e) => {
                    this.counterChange(e, "borderRadius");
                  }}
                />
              </div>
            </TabPane>
            <TabPane tabId="2" className="general-tab">
              <LinkOption
                pagesList={this.props.pagesList}
                userID={this.props.userID}
                sessionID={this.props.sessionID}
                ID={this.props.ID}
                Link={this.props.Link}
                LinkName={this.props.LinkName}
                LinkType={this.props.LinkType}
                LinkOpen={this.props.LinkOpen}
                UseSocial={this.props.UseSocial}
                closePopup={this.props.closePopup}
                layout={this.props.layout}
              />
            </TabPane>
          </TabContent>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ImageSetting);
